<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="custom-field-number-container">
	<mat-form-field class="full-width">
		<mat-label>{{ customField.view.label }}</mat-label>
		<!-- https://github.com/angular/components/issues/12803 -->
		<input
			matInput
			class="mat-custom-field-number-input"
			automationId="customFieldNumberInput"
			[formControl]="internalField"
			type="number"
			(focus)="internalFocused()"
			(blur)="internalBlurred()"
		/>
		<span
			[ngClass]="
				internalField.disabled
					? ['mat-custom-field-number-suffix', 'disabled-suffix']
					: 'mat-custom-field-number-suffix'
			"
		>
			{{ customField.view.unit }}
		</span>
		<!-- <mat-error *ngIf="internalField.errors?.required">Required</mat-error> -->
	</mat-form-field>
</div>
